export default __webpack_public_path__ + "static/media/confirmed.93dee58b.svg";